import { defineMessages } from 'react-intl';

const messages = defineMessages({
  exportEvents: {
    id: 'repvisits.events.exportEvents',
    defaultMessage: 'Export',
  },
  exportEventsHeader: {
    id: 'repvisits.events.exportEventsHeader',
    defaultMessage: 'Export Settings',
  },
  exportEventsFrom: {
    id: 'repvisits.events.exportEventsFrom',
    defaultMessage: 'From',
  },
  exportEventsTo: {
    id: 'repvisits.events.exportEventsTo',
    defaultMessage: 'To',
  },
  exportEventsCancel: {
    id: 'repvisits.events.exportEventsCancel',
    defaultMessage: 'Cancel',
  },
  exportEventsPlaceholder: {
    id: 'repvisits.events.exportEventsPlaceholder',
    defaultMessage: 'Upgrade your account to export calendar events.',
  },
  exportEventsEmptyContent: {
    id: 'repvisits.events.exportEventsEmptyContent',
    defaultMessage: 'There are no events within the selected date range',
  },
  exportEventsErrorContent: {
    id: 'repvisits.events.exportEventsErrorContent',
    defaultMessage: 'Something went wrong while exporting your Appointments.',
  },
  exportEventsDownloadReady: {
    id: 'repvisits.events.exportEventsDownloadReady',
    defaultMessage: 'Your Export is Ready',
  },
  exportEventsDownloading: {
    id: 'repvisits.events.exportEventsDownloading',
    defaultMessage: 'Preparing your Export...',
  },
  exportEventsDownload: {
    id: 'repvisits.events.exportEventsDownload',
    defaultMessage: 'Download Export',
  },
  exportEventsDownloadSingle: {
    id: 'repvisits.events.exportEventsDownloadSingle',
    defaultMessage: 'Download My Appointments',
  },
  exportEventsDownloadAll: {
    id: 'repvisits.events.exportEventsDownloadAll',
    defaultMessage: 'Download All Staff Appointments',
  },
  exportEventsDownloadIE: {
    id: 'repvisits.events.exportEventsDownloadIE',
    defaultMessage: 'Please save the CSV file using the download bar',
  },
});

export default messages;
